export default __webpack_public_path__ + "static/media/rocket_anim_148.e12a9a84.png";